"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_structures_1 = require("@tableau/data-structures");
var globalTypes_1 = require("../../../../gen-src/queries/globalTypes");
var FieldIcon_1 = require("../types/FieldIcon");
exports.geographicalSemanticRolePrefix = '[Geographical]';
function isContinuous(field) {
    // NOMINAL and ORDINAL are discrete; QUANTITATIVE is continuous.
    // If UNKNOWN, default to discrete.
    return field.dataCategory === globalTypes_1.FieldRoleCategory.QUANTITATIVE;
}
exports.isContinuous = isContinuous;
function isGeographical(fieldMaybeWithRole) {
    var fieldWithRole = fieldMaybeWithRole;
    return !!fieldWithRole.semanticRole && fieldWithRole.semanticRole.startsWith(exports.geographicalSemanticRolePrefix);
}
exports.isGeographical = isGeographical;
function iconForBinField(field) {
    if (field.dataCategory === null) {
        return null;
    }
    return isContinuous(field) ? FieldIcon_1.FieldIcon.NumericBinContinuous : FieldIcon_1.FieldIcon.NumericBinDiscrete;
}
exports.iconForBinField = iconForBinField;
function iconForCalculatedField(field) {
    if (isGeographical(field)) {
        return isContinuous(field) ? FieldIcon_1.FieldIcon.GeoCalcContinuous : FieldIcon_1.FieldIcon.GeoCalcDiscrete;
    }
    else if (field.dataCategory === null) {
        return null;
    }
    else {
        switch (field.dataType) {
            case globalTypes_1.FieldDataType.BOOLEAN:
                // Bools are always discrete.
                return FieldIcon_1.FieldIcon.BoolCalc;
            case globalTypes_1.FieldDataType.DATE:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.DateCalcContinuous : FieldIcon_1.FieldIcon.DateCalcDiscrete;
            case globalTypes_1.FieldDataType.DATETIME:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.DateTimeCalcContinuous : FieldIcon_1.FieldIcon.DateTimeCalcDiscrete;
            case globalTypes_1.FieldDataType.INTEGER:
            case globalTypes_1.FieldDataType.REAL:
            case globalTypes_1.FieldDataType.TABLE:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.NumberCalcContinuous : FieldIcon_1.FieldIcon.NumberCalcDiscrete;
            case globalTypes_1.FieldDataType.SPATIAL:
                // Spatial fields display as geographical.
                return isContinuous(field) ? FieldIcon_1.FieldIcon.GeoCalcContinuous : FieldIcon_1.FieldIcon.GeoCalcDiscrete;
            case globalTypes_1.FieldDataType.STRING:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.TextCalcContinuous : FieldIcon_1.FieldIcon.TextCalcDiscrete;
            case globalTypes_1.FieldDataType.TUPLE:
            // Not sure what this means, and there's no obvious icon for it.
            case globalTypes_1.FieldDataType.UNKNOWN:
            case null:
                return null;
            default:
                data_structures_1.assertNever(field.dataType);
                return null;
        }
    }
}
exports.iconForCalculatedField = iconForCalculatedField;
function iconForColumnField(field) {
    if (isGeographical(field)) {
        return isContinuous(field) ? FieldIcon_1.FieldIcon.GeoContinuous : FieldIcon_1.FieldIcon.GeoDiscrete;
    }
    else if (field.dataCategory === null) {
        return null;
    }
    else {
        switch (field.dataType) {
            case globalTypes_1.FieldDataType.BOOLEAN:
                // Bools are always discrete.
                return FieldIcon_1.FieldIcon.Bool;
            case globalTypes_1.FieldDataType.DATE:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.DateContinuous : FieldIcon_1.FieldIcon.DateDiscrete;
            case globalTypes_1.FieldDataType.DATETIME:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.DateTimeContinuous : FieldIcon_1.FieldIcon.DateTimeDiscrete;
            case globalTypes_1.FieldDataType.INTEGER:
            case globalTypes_1.FieldDataType.REAL:
            case globalTypes_1.FieldDataType.TABLE:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.NumberContinuous : FieldIcon_1.FieldIcon.NumberDiscrete;
            case globalTypes_1.FieldDataType.SPATIAL:
                // Spatial fields display as geographical.
                return isContinuous(field) ? FieldIcon_1.FieldIcon.GeoContinuous : FieldIcon_1.FieldIcon.GeoDiscrete;
            case globalTypes_1.FieldDataType.STRING:
                return isContinuous(field) ? FieldIcon_1.FieldIcon.TextContinuous : FieldIcon_1.FieldIcon.TextDiscrete;
            case globalTypes_1.FieldDataType.TUPLE:
            // Not sure what this means, and there's no obvious icon for it.
            case globalTypes_1.FieldDataType.UNKNOWN:
            case null:
                return null;
            default:
                data_structures_1.assertNever(field.dataType);
                return null;
        }
    }
}
exports.iconForColumnField = iconForColumnField;
function iconForGroupField(field) {
    if (field.fieldsReferencedByGroup.length > 0 && isGeographical(field.fieldsReferencedByGroup[0])) {
        return FieldIcon_1.FieldIcon.GroupGeo;
    }
    else {
        return FieldIcon_1.FieldIcon.Group;
    }
}
exports.iconForGroupField = iconForGroupField;
function iconForNonDatasourceField(field) {
    switch (field.__typename) {
        case 'BinField':
            return iconForBinField(field);
        case 'CalculatedField':
            return iconForCalculatedField(field);
        case 'ColumnField':
            return iconForColumnField(field);
        case 'CombinedField':
            // Combined fields (that are not combined set fields) are always text.
            return FieldIcon_1.FieldIcon.TextDiscrete;
        case 'CombinedSetField':
            // Combined set fields display as sets.
            return FieldIcon_1.FieldIcon.Set;
        case 'DatasourceField':
            // Don't expect datasource fields here; they're handled by iconForField.
            return null;
        case 'GroupField':
            return iconForGroupField(field);
        case 'HierarchyField':
            return FieldIcon_1.FieldIcon.Hierarchy;
        case 'SetField':
            return FieldIcon_1.FieldIcon.Set;
        default:
            data_structures_1.assertNever(field);
            return null;
    }
}
exports.iconForNonDatasourceField = iconForNonDatasourceField;
function iconForField(field) {
    if (field.__typename !== 'DatasourceField') {
        return iconForNonDatasourceField(field);
    }
    else if (field.remoteField) {
        return iconForNonDatasourceField(field.remoteField);
    }
    else {
        return null;
    }
}
exports.iconForField = iconForField;
//# sourceMappingURL=FieldFunctions.js.map